import { Injectable } from '@angular/core';
import {Http, Response} from "@angular/http";
import {UtilService} from "../util";
import {Observable} from "rxjs/Observable";
import {Race} from "../../models/race.model";

@Injectable()
export class RaceService {

  constructor(private http: Http, private utilService: UtilService) { }

  getRaces(): Observable<Array<Race>> {
    const url: string = "/core/races?tag_list=prf_races_list";

    return this.http
      .get(url)
      .map((res: Response) => {
        return this.utilService.outputParser(res) || {};
      })
      .catch(this.utilService.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/race/race.service.ts